(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemBulkEditErrorDialogCtrl', ItemBulkEditErrorDialogCtrl);

    ItemBulkEditErrorDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'ItemService', 'errorText', 'itemProducingError', 'itemEditState'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog detailing error for an item bulk edit operation.
     */
    function ItemBulkEditErrorDialogCtrl(DialogInstance, DialogService, ItemService, errorText, itemProducingError, itemEditState) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.itemType = 'Item';
        vm.errorText = errorText;
        vm.itemProducingError = itemProducingError;
        vm.itemLink = null;

        activate();

        function activate() {
            if (!_.isNil(itemProducingError)) {
                var itemMetaData = ItemService.getItemTypeMetaData(itemProducingError);
                if (!_.isNil(itemMetaData)) {
                    vm.itemType = itemMetaData.singular;
                } else if (!_.isNil(itemProducingError.Type)) {
                    vm.itemType = itemProducingError.Type;
                }

                vm.itemLink = ItemService.getItemLink(itemProducingError);
            }
        }

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
